<template>
  <div class="modal fade" id="IntroDetailModal" tabindex="-1" aria-labelledby="IntroDetailModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
      <div class="modal-content border-0 shadow">
        <!-- 模態框頭部 - 添加圖片背景 -->
        <div class="modal-header position-relative py-4" :style="{
          backgroundColor: '#1398C9',
          backgroundImage: detail?.img ? `url(${detail.img})` : 'none',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundBlendMode: 'overlay',
          minHeight: '120px'
        }">
          <div class="overlay position-absolute top-0 start-0 w-100 h-100 z-index-2" :style="{ backgroundColor: 'rgba(19, 152, 201, 0.85)' }"></div>
          <div class="position-relative z-index-1 text-center w-100">
            <h3 class="modal-title text-white fw-bold mb-2" id="IntroDetailModalLabel">{{ detail?.title }}</h3>
            <div class="badge bg-light text-primary px-3 py-2 fs-6" v-if="detail?.description.slogan">{{ detail?.description.slogan }}</div>
          </div>
          <button type="button" class="btn-close btn-close-white position-absolute end-0 top-0 mt-2 me-2 z-index-1" data-bs-dismiss="modal"
            aria-label="Close"></button>
        </div>

        <div class="modal-body text-start p-4">
          <!-- 詳細信息部分 -->
          <div class="row mb-4">
            <div class="col-12">
              <h5 class="mb-3 d-flex align-items-center border-bottom pb-2">
                <i class="bi bi-info-circle-fill me-2" :style="{ color: '#1398C9' }"></i>
                {{ $t('details') }}
              </h5>

              <div class="card border-0 shadow-sm mb-4">
                <ul class="list-group list-group-flush">
                  <li class="list-group-item py-3 border-start border-4 transition-hover" v-for="(txt, index) in detail?.description.details" :key="index"
                    :style="{ borderLeftColor: getRandomColor(index) + ' !important' }">
                    <div class="d-flex align-items-start">
                      <div class="feature-icon me-3 mt-1">
                        <i class="bi" :class="getIconForIndex(index)"></i>
                      </div>
                      <p class="mb-0 fw-semibold">{{ txt }}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!-- 平台/工具部分 -->
          <div class="row">
            <div class="col-12">
              <h5 class="mb-3 d-flex align-items-center border-bottom pb-2">
                <i class="bi bi-tools me-2" :style="{ color: '#8370F2' }"></i>
                {{ $t('platforms') }}
              </h5>

              <div class="d-flex flex-wrap gap-2 mb-3">
                <span v-for="(skill, index) in detail?.tool" :key="index" class="badge rounded-pill py-2 px-3 shadow-sm transition-scale"
                  :style="{ backgroundColor: getToolColor(skill) }">
                  <i class="bi me-1" :class="getIconForTool(skill)"></i>
                  {{ skill }}
                </span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detail: null,
      colors: ['#1398C9', '#8370F2', '#DA6058', '#28a745', '#fd7e14', '#6f42c1'],
      toolColors: {
        'vue.js': '#42b883',
        'bootstrap': '#7952b3',
        'gcp': '#4285F4',
        'firebase': '#4285F4',
        'Python': '#3776AB',
        'Golang': '#00ADD8',
        'node.js': '#339933',
        'Flutter': '#02569B',
        'Swift': '#02569B',
        'Kotlin': '#02569B',
        'JAVA': '#02569B',
        'Objective-C': '#02569B',
        'iOS': '#333333',
        'Android': '#333333',
        'Linux': '#333333',
        'Windows': '#333333',
        'MAC': '#333333',
      },
      icons: [
        'bi-check-circle-fill',
        'bi-lightning-fill',
        'bi-star-fill',
        'bi-shield-check',
        'bi-graph-up',
        'bi-gear-fill'
      ]
    }
  },
  methods: {
    setDetail(item) {
      this.detail = item;
    },
    getRandomColor(index) {
      return this.colors[index % this.colors.length];
    },
    getIconForIndex(index) {
      return this.icons[index % this.icons.length];
    },
    getToolColor(tool) {
      return this.toolColors[tool] || '#8370F2';
    },
    getIconForTool(tool) {
      const iconMap = {
        'vue.js': 'bi-code-slash',
        'bootstrap': 'bi-bootstrap-fill',
        'gcp': 'bi-cloud-fill',
        'firebase': 'bi-database-fill',
        'Python': 'bi-filetype-py',
        'Golang': 'bi-code-square',
        'node.js': 'bi-nodejs',
        'Flutter': 'bi-phone-fill',
        'Swift': 'bi-apple',
        'iOS': 'bi-apple',
        'Android': 'bi-android2',
        'Linux': 'bi-terminal-fill',
        'Windows': 'bi-windows',
        'MAC': 'bi-laptop',
        'Excel': 'bi-file-earmark-excel-fill',
        'Word': 'bi-file-earmark-word-fill',
        'PDF': 'bi-file-earmark-pdf-fill',
        '微軟Excel': 'bi-file-earmark-excel-fill',
        'Google試算表': 'bi-table',
        'Apps Script': 'bi-code',
        'App Sheet': 'bi-grid-3x3-gap-fill',
        'C/C++': 'bi-code-slash',
        'C#': 'bi-hash',
        'Java': 'bi-cup-hot-fill',
        'Kotlin': 'bi-code',
        'Objective-C': 'bi-apple',
        'Electron App': 'bi-app',
        '投影片': 'bi-easel-fill',
        '雲端共享文件': 'bi-cloud-arrow-up-fill'
      };

      return iconMap[tool] || 'bi-check-circle-fill';
    },
    handleContact() {
      // 這裡可以添加聯繫功能，例如打開聯繫表單或發送郵件
      this.$emit('contact-request', this.detail);
    }
  }
}
</script>

<style scoped>
.transition-hover {
  transition: all 0.3s ease;
}

.transition-hover:hover {
  transform: translateX(5px);
  background-color: rgba(19, 152, 201, 0.05);
}

.transition-scale {
  transition: all 0.2s ease;
}

.transition-scale:hover {
  transform: scale(1.05);
}

.modal-content {
  border-radius: 15px;
  overflow: hidden;
}

.modal-header {
  border-bottom: none;
}

.modal-footer {
  border-top: none;
}

.badge {
  font-size: 0.9rem;
  font-weight: 500;
}

.btn-close {
  opacity: 0.8;
  transition: opacity 0.2s ease;
}

.btn-close:hover {
  opacity: 1;
}

.feature-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1398C9;
}

.z-index-1 {
  z-index: 1;
}

.border-bottom {
  border-color: rgba(0, 0, 0, 0.1) !important;
}

/* 淡入動畫 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-body {
  animation: fadeIn 0.5s ease-out;
}

/* 工具標籤懸停效果 */
.badge {
  transition: all 0.3s ease;
}

.badge:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
</style>